module.exports = __webpack_public_path__ + "img/hebei.13a99575.png";